export default {

  displayInline: 'inline',
  displayNone: 'none',

  textTransformUpperCase: 'uppercase',
  textTransformNone: 'none',

  fontWeightBold: 'bold',
  fontWeightNormal: 'normal',

  fontStyleItalic: 'italic',
  fontStyleNormal: 'normal',

  textDecorationUnderline: 'underline',
  textDecorationNone: 'none',

  textOverflowEllipsis: 'ellipsis',
  textOverflowNone: '',

  textAlignLeft: 'left',
  textAlignCenter: 'center',
  textAlignRight: 'right',

  backgroundSizeStretch: '100% 100%',
  backgroundSizeAuto: '',

};
